import React, { useContext, useEffect, useState } from 'react'
import Axios from 'axios';
import StateContext from '../../StateContext';
import { firestore } from '../../firebase';

function FavoriteBlogPost({recipeId, recipe}) {

    const appState = useContext(StateContext)

    const [isLoading, setIsLoading] = useState(true)
    const [liked, setLiked] = useState(false)
    const [likeCount, setLikeCount] = useState(0)
    const [favoriteId, setFavoriteId] = useState()

    useEffect(() => {
        setIsLoading(true)
        try {
            const favoriteRef = firestore.collection("favorites");
            favoriteRef.where("recipe_id", "==", recipeId).onSnapshot(({docs}) => {
                const favorites = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setLikeCount(favorites.length)
                const hasUserFavorited = favorites.filter(favorite => {
                    
                    return favorite.user_id === appState.userId
                })
                if (hasUserFavorited.length > 0) {
                    setLiked(true)
                    setFavoriteId(hasUserFavorited[0].id)
                }
            })
        } catch (error) {
            
        }
        setIsLoading(false)

    }, [recipeId, likeCount])

    async function favoritePost(e) {
        e.preventDefault();

        try {
            const favoriteRef = firestore.collection("favorites");
            const data = {
                user_id: appState.userId,
                recipe_id: recipeId,
                recipe_image: recipe.imageUrl,
                recipe_title: recipe.title,
                recipe_author: recipe.author_name
            }
            favoriteRef.add(data);
            setLiked(true)
            setLikeCount(likeCount+1)
        } catch (error) {
            console.log(error)
        }
    }

    async function removeFavoritePost(e) {
        e.preventDefault();

        try {
            const favoriteRef = firestore.collection("favorites").doc(favoriteId);
            favoriteRef.delete();
            setLiked(false)
        } catch (error) {
            console.log(error)
        }
    }

    if (isLoading) return <i className="far fa-bookmark"></i>

    return (
        <>
        {liked ? (
            <form onSubmit={removeFavoritePost}>
                <button 
                    style={{backgroundColor: "transparent", border: "none", marginLeft: "-7px"}} 
                    disabled={isLoading}
                >
                <i className={liked ? "fa fa-bookmark" : "far fa-bookmark"}></i> {+likeCount}
                </button>
            </form>
        ) 
        :
            <form onSubmit={favoritePost}>
                <button 
                    style={{backgroundColor: "transparent", border: "none", marginLeft: "-7px"}} 
                    disabled={isLoading}
                >
                <i className={liked ? "fa fa-bookmark" : "far fa-bookmark"}></i> {+likeCount}
                </button>
            </form>
        }

        </>
    )
}
export default FavoriteBlogPost